import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import PAGEURL from '../../constants/PAGEURL'
import { DefaultLayout } from '../../layouts'
import Head from 'next/head'
import AppContext from '../../components/common/AppContext.js'

class About extends React.Component {

  render () {
    return (
      <div className="home">
        <Head>
          <title>{'SimplyBuy | About'}</title>
          <meta name='description' content={"Product Picker | Get recommendations unique to your needs in just minutes! Snowboards, Skis, Mountain Bikes, and more."}/>
        </Head>
        <div className="home-container">
          <h1 className="large-title blue">About</h1>
          <div className="about">
            Information is everywhere on the internet, which is great—until it isn’t.
            We've all experienced the frustration of sitting down to buy a product without knowing where to start.
            We spend hours watching videos and reading reviews, only to realize we haven't made any progress in narrowing down our options.
            Nowadays, the challenge isn't a lack of information; it's sifting through the information overload.
            <br/>
            <br/>
            That is where SimplyBuy comes in.
            Our product pickers, crafted and endorsed by industry experts, suggest the best products for your unique needs.
            Our goal is to direct you to the same product you would eventually buy after hours of reseach, in as little as two minutes.
            Let SimplyBuy do the hard work for you and bring back the joy of online shopping.
            <br/>
            <br/>
            As an Amazon Associate and affiliate for companies such as evo, and JensonUSA we may earn a small commission when you make a purchase through links on our recommended products at no additional cost to you.
            <br/>
            <br/>
            <div className="psg-container pt-none">
              See the SimplyBuy process for yourself. Select a product to get started:
              <div className="product-category mt-md">Outdoor/Sports Gear</div>
              <div className="products-flex">
                <div className="product-container">
                  <Link href={PAGEURL.PRODUCT_PICKER('mountain-bike', '0')}>
                      <div className="product-option">
                        Mountain Bikes
                      </div>
                  </Link>
                </div>
                <div className="product-container">
                  <Link href={'/product-picker/pickleball-paddle/0'}>
                      <div className="product-option">
                        Pickleball Paddles
                      </div>
                  </Link>
                </div>
                  <div className="product-container">
                    <Link href={'/product-picker/ski/0'}>
                        <div className="product-option">
                          Skis
                        </div>
                    </Link>
                  </div>
                  <div className="product-container">
                    <Link href={'/product-picker/snowboard/0'}>
                        <div className="product-option">
                          Snowboards
                        </div>
                    </Link>
                  </div>
                  <div className="product-container">
                    <Link href={'/product-picker/snowboard-binding/0'}>
                        <div className="product-option">
                          Snowboard Bindings
                        </div>
                    </Link>
                  </div>
                  <div className="product-container">
                    <Link href={PAGEURL.PRODUCT_PICKER('snowboard-boots', '0')}>
                        <div className="product-option">
                          Snowboard Boots
                        </div>
                    </Link>
                  </div>
                </div>
              <div className="product-category">Tech</div>
              <div className="products-flex">
                <div className="product-container">
                  <Link href={'/product-picker/headphones/0'}>
                      <div className="product-option">
                        Headphones
                      </div>
                  </Link>
                </div>
                <div className="product-container">
                  <Link href={'/product-picker/monitor/0'}>
                      <div className="product-option">
                        Monitors
                      </div>
                  </Link>
                </div>
                <div className="product-container">
                  <Link href={'/product-picker/tv/0'}>
                      <div className="product-option">
                        TVs
                      </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

About.contextType = AppContext;

export default About
